import {
  Legend,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart as ReRadarChart,
  ResponsiveContainer,
} from "recharts";

import { perspectiveLabels } from "../../lib/diagramTypes";
import { perspective_colors } from "../../lib/diagramTypes";

export default function RadarChart({
  evaluationType,
  averagesData,
  all_perspectives,
  displayedPerspectives,
  displayQuestionDetails,
  displaySubdimensionDetails,
}) {
  return (
    <ResponsiveContainer height={700}>
      <ReRadarChart
        layout="vertical"
        width={500}
        height={500}
        data={averagesData}
        margin={{
          top: 30,
          right: 30,
          left: 110,
          bottom: 30,
        }}
      >
        <PolarGrid />
        <PolarAngleAxis
          dataKey="name"
          type="category"
          onClick={({ value }) => {
            if (evaluationType === "question") displayQuestionDetails(value);
            if (evaluationType === "subdimension")
              displaySubdimensionDetails(value);
          }}
        />
        <PolarRadiusAxis
          angle={90}
          domain={[0, 4]}
          tickFormatter={(tick) => (tick === 0 ? "" : tick)}
        />
        {all_perspectives.map((p, i) => (
          <Radar
            id={p}
            key={p}
            dataKey={p}
            stroke={perspective_colors[p]}
            strokeWidth={3}
            strokeOpacity={displayedPerspectives.includes(p) ? 1 : 0}
            fill={perspective_colors[p]}
            fillOpacity={0}
          />
        ))}
        <Legend
          payload={
            all_perspectives.includes("Lehrer*innen")
              ? [
                  {
                    dataKey: "Lehrer*innen",
                    type: "rect",
                    color: perspective_colors["Lehrer*innen"],
                    value: perspectiveLabels.get("Lehrer*innen"),
                  },
                  {
                    dataKey: "Beobachter*innen",
                    type: "rect",
                    color: perspective_colors["Beobachter*innen"],
                    value: perspectiveLabels.get("Beobachter*innen"),
                  },
                ]
              : [
                  {
                    dataKey: "Schüler*innen",
                    type: "rect",
                    color: perspective_colors["Schüler*innen"],
                    value: perspectiveLabels.get("Schüler*innen"),
                  },
                ]
          }
        />
      </ReRadarChart>
    </ResponsiveContainer>
  );
}
